import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Calendar, Tag } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const ResourceCard = ({ resource }) => (
  <Link
    to={`/resources/${resource.slug}`}
    className="group rounded-2xl overflow-hidden border border-gray-200 hover:border-[#00BCE4]/30 transition-all duration-500 hover:shadow-xl hover:shadow-[#00BCE4]/5 block"
  >
    <div className="relative overflow-hidden aspect-[16/10]">
      {resource.image ? (
        <img
          src={resource.image?.startsWith('http') ? resource.image : `${BACKEND_URL}${resource.image}`}
          alt={resource.title}
          loading="lazy"
          className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
          onError={(e) => {
            e.target.style.display = 'none';
            e.target.parentElement.style.background = 'linear-gradient(135deg, #00BCE4 0%, #0a0b10 100%)';
          }}
        />
      ) : (
        <div className="w-full h-full bg-gradient-to-br from-[#00BCE4] to-[#0a0b10]"></div>
      )}
      <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"></div>
      <div className="absolute top-4 left-4">
        <span className="inline-flex items-center gap-1.5 bg-[#00BCE4] text-white text-xs font-semibold px-3 py-1.5 rounded-full">
          <Tag size={12} />
          {resource.category}
        </span>
      </div>
    </div>

    <div className="p-6">
      <h3
        className="text-lg font-bold text-gray-900 mb-3 group-hover:text-[#00BCE4] transition-colors duration-300 line-clamp-2"
        style={{ fontFamily: 'Outfit, sans-serif' }}
      >
        {resource.title}
      </h3>
      <p
        className="text-sm text-gray-500 mb-4 leading-relaxed line-clamp-3"
        style={{ fontFamily: 'Inter, sans-serif' }}
      >
        {resource.excerpt}
      </p>
      <div className="flex items-center justify-between">
        <span className="flex items-center gap-1.5 text-xs text-gray-400">
          <Calendar size={12} />
          {resource.date}
        </span>
        <span className="text-sm font-semibold text-[#00BCE4] flex items-center gap-1 group-hover:gap-2 transition-all duration-300">
          Read More
          <ArrowRight size={14} />
        </span>
      </div>
    </div>
  </Link>
);

export default ResourceCard;
